"use client";

import { Modal, ModalContent, ModalBody, Button } from "@nextui-org/react";
import { Ticket } from "lucide-react";

interface ConnectStripeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ConnectStripeModal({ isOpen, onClose }: ConnectStripeModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      className="bg-[#1C1B1F] dark"
      classNames={{
        backdrop: "bg-[#1C1B1F]/50 backdrop-blur-sm",
      }}
    >
      <ModalContent>
        <ModalBody className="p-8 text-center">
          <div className="flex flex-col items-center gap-6">
            <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center">
              <Ticket className="w-8 h-8" />
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-2">Accept Payments</h2>
              <p className="text-gray-400 mb-4">
                This calendar is not yet set up to accept payments.
              </p>
              <p className="text-gray-400">
                We use <span className="text-white">Stripe</span> to process payments. Connect or set up a Stripe account to start accepting payments. It usually takes less than 5 minutes.
              </p>
            </div>
            <Button
              color="primary"
              size="lg"
              className="w-full"
              onPress={() => {
                // TODO: Implement Stripe connect
                console.log("Connect Stripe");
                onClose();
              }}
            >
              Connect Stripe
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}